// StarsBackground.jsx
import { useEffect, useRef } from "react";
import "./stars.css";

const StarsBackground = ({ stars = 300, vel = 0.3, radius = 1 }) => {
  const canvasRef = useRef(null);
  const starsArray = useRef([]);

  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");

    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    const center = { x: window.innerWidth / 2, y: window.innerHeight / 2 };

    class Star {
      constructor() {
        this.init();
      }

      init() {
        this.x = center.x;
        this.y = center.y;
        this.radius = Math.random() * radius;
        this.maxLineWidth = Math.max(0.1, this.radius * 0.6);
        this.lineWidth = this.maxLineWidth * 0.4;
        this.vel = {
          x: (Math.random() * 1 - 0.5) * vel, // Movimento inicial super baixo
          y: (Math.random() * 1 - 0.5) * vel,
        };
      }

      update() {
        this.vel.x *= 1.000; // Aceleração mínima
        this.vel.y *= 1.000;
        this.lineWidth += 0.002; // Crescimento da linha quase imperceptível
        this.x0 = this.x;
        this.y0 = this.y;
        this.x += this.vel.x;
        this.y += this.vel.y;
        this.draw();
        if (this.isDead()) this.init();
      }

      draw() {
        context.beginPath();
        context.moveTo(this.x0, this.y0);
        context.lineTo(this.x, this.y);
        context.lineWidth = Math.min(this.lineWidth, this.maxLineWidth);
        context.strokeStyle = "white";
        context.stroke();
      }

      isDead() {
        return (
          this.x < 0 ||
          this.x > canvas.width ||
          this.y < 0 ||
          this.y > canvas.height
        );
      }
    }

    const startAnimation = () => {
      starsArray.current = [];
      for (let i = 0; i < stars; i++) {
        setTimeout(() => {
          starsArray.current.push(new Star());
        }, i * 150); // Maior espaçamento para suavidade
      }
    };

    const animate = () => {
      requestAnimationFrame(animate);
      //   context.fillStyle = "rgba(1, 4, 35, 0.8)";
      context.fillStyle = "black";
      context.fillRect(0, 0, canvas.width, canvas.height);
      starsArray.current.forEach((star) => star.update());
    };

    resizeCanvas();
    startAnimation();
    animate();

    window.addEventListener("resize", resizeCanvas);
    return () => window.removeEventListener("resize", resizeCanvas);
  }, [stars, vel, radius]);

  return (
    <canvas
      ref={canvasRef}
      className={`stars-canvas stars-canvas--fullscreen`}
      aria-hidden="true"
    />
  );
};

export default StarsBackground;
